// extracted by mini-css-extract-plugin
export default {"logo_wrapper":"A_Logo_logo_wrapper__zOw1j","logo_default_wrapper":"A_Logo_logo_default_wrapper__+O9pe"};